import { useState, useEffect, useReducer } from "react";
import { Button, Card, Col, FormGroup, Input, Row } from "reactstrap";
import DataGrid from "../../components/dataGrid/DataGrid";
import {
  TransporterData,
  deleteTransporter,
  exportExcelTransporter,
  getTransporters,
  updateTransporter,
} from "../../services/transporters.service";
import { Link, useLocation, useNavigate } from "react-router-dom";
import QueryString from "qs";
import { Edit, Trash2 } from "react-feather";
import FormInput from "../../components/FormInput";
import { toast } from "react-hot-toast";
import Swal from "sweetalert2";

const initialState = {
  results: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  totalResults: 0,
  startIndex: 1,
  endIndex: 10,
};

function reducer(state: any, action: any) {
  switch (action.type) {
    case "SET_DATA":
      return action.payload;
    case "UPDATE_STATUS":
      return {
        ...state,
        data: state.results.map((row: any) =>
          row.id === action.payload.id ? { ...row, status: action.payload.status } : row,
        ),
      };
    default:
      return state;
  }
}

function Transporters() {
  const [filterData, setFilterData] = useState({
    search: "",
  });
  const [data, dispatch] = useReducer(reducer, initialState);
  const location = useLocation();
  const navigate = useNavigate();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });

  const columns = [
    {
      selector: (row: any) => row.serialNumber,
      name: "S.No.",
      sortable: false,
      //   wrap: true,
      maxWidth: "70px",
      minWidth: "70px",
    },

    {
      selector: (row: TransporterData) => row.name,
      name: "Transporter Name",
      sortable: false,
      wrap: true,
    },

    {
      selector: (row: TransporterData) => row.state,
      name: "State",
      sortable: false,
      wrap: true,
    },
    {
      selector: (row: TransporterData) => row.city,
      name: "City",
      sortable: false,
      wrap: true,
    },

    {
      selector: (row: any) => (
        <FormGroup switch className='p-0'>
          <Input
            className='m-1'
            type='switch'
            role='switch'
            style={{
              cursor: "pointer",
            }}
            User
            checked={row.status}
            onClick={() => handleUpdateStatus(row.id, !row.status)}
          />
        </FormGroup>
      ),
      name: "Status",
      sortable: false,
      maxWidth: "80px",
      minWidth: "80px",
    },
    {
      selector: (row: any) => (
        <>
          <Link
            className='me-1'
            to={`edit/${row.id}?${QueryString.stringify({
              redirect: location.pathname + location.search,
            })}`}
          >
            <Edit size={15} />
          </Link>

          <Trash2
            className='text-danger'
            onClick={() => {
              Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
              }).then((result) => {
                if (result.isConfirmed) {
                  deleteTransporter(row.id)
                    .then(() => {
                      getTransporters({ page: 1 }).then((response: any) => {
                        setData(response.data);
                      });
                      Swal.fire("Deleted!", "The transporter has been deleted.", "success");
                    })
                    .catch(() => {
                      Swal.fire("Error!", "There was an error deleting the transporter.", "error");
                    });
                }
              });
            }}
            size={15}
          />
        </>
      ),
      name: "Actions",
      sortable: false,
      center: true,
      maxWidth: "90px",
      minWidth: "90px",
    },
  ];

  const setData = (data: any) => {
    dispatch({ type: "SET_DATA", payload: data });
  };
  useEffect(() => {
    const { page, search } = query;

    const queryParams: any = {
      page,
      search,
    };

    // Remove empty keys from queryParams
    Object.keys(queryParams).forEach((key) => {
      if (!queryParams[key]) {
        delete queryParams[key];
      }
    });
    getTransporters(queryParams).then((response: any) => {
      setData(response.data);
    });
  }, [location.search]);

  const handleUpdateStatus = (id: string, status: boolean) => {
    updateTransporter(id, { status }).then(() => {
      dispatch({ type: "UPDATE_STATUS", payload: { id, status } });
      getTransporters({ page: data.page }).then((response: any) => {
        setData(response.data);
      });
    });
  };

  const handleFilter = () => {
    const queryParams: any = { ...query, page: 1, ...filterData };

    Object.keys(queryParams).forEach((key) => {
      if (!queryParams[key]) {
        delete queryParams[key];
      }
    });

    const queryString = QueryString.stringify(queryParams);
    navigate(`${location.pathname}${Object.keys(queryParams).length > 0 ? "?" + queryString : ""}`);
  };
  const handleClearFilter = () => {
    setFilterData({ search: "" });
    const queryParams = { page: 1 };
    const queryString = QueryString.stringify(queryParams);
    navigate(`${location.pathname}?${queryString}`);
  };
  return (
    <div className='d-flex flex-column h-100 px-sm-1 w-100 pb-sm-1'>
      <Row className='align-items-center mb-2'>
        <Col sm>
          <h1 className='my-1 fw-bold h4'>Transporter Master</h1>
        </Col>
        <Col sm='auto'>
          <div className='justify-content-between'>
            <Link
              to={`add?${QueryString.stringify({
                redirect: location.pathname + location.search,
              })}`}
              className='btn btn-sm btn-primary my-1 text-white'
            >
              Add New
            </Link>
          </div>
        </Col>
      </Row>

      <div className='flex-grow-1 overflow-auto'>
        <Card className='h-100 p-3 w-100 '>
          <div className='d-flex flex-column h-100 rounded-0'>
            <DataGrid
              columns={columns}
              data={data}
              filterByDate={true}
              FilterSubHeader={true}
              filterData={filterData}
              setFilterData={setFilterData}
              subHeaderComponent={
                <Row>
                  <Col md={2}>
                    <FormInput
                      name='search'
                      label='Name'
                      placeholder='Name'
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      value={filterData.search}
                    />
                  </Col>

                  <Col md={2} className='mt-1'>
                    <div className='mt-4'>
                      <Button
                        color='primary'
                        size='sm'
                        className='me-2'
                        onClick={() => handleFilter()}
                      >
                        Filter
                      </Button>
                      <Button
                        color='danger'
                        size='sm'
                        className='me-2'
                        onClick={() => handleClearFilter()}
                      >
                        Clear
                      </Button>
                    </div>
                  </Col>
                  <Col md={8} className='mt-1'>
                    <div className='mt-4 text-end'>
                      <Button
                        color='primary'
                        size='sm'
                        onClick={() => {
                          const { search } = query;

                          const queryParams: any = {
                            search,
                          };

                          // Remove empty keys from queryParams
                          Object.keys(queryParams).forEach((key) => {
                            if (!queryParams[key]) {
                              delete queryParams[key];
                            }
                          });
                          exportExcelTransporter(queryParams)
                            .then((response) => {
                              const blobURL = URL.createObjectURL(response.data);
                              const anchor = document.createElement("a");
                              anchor.href = blobURL;
                              anchor.download = "Transporter Master.xlsx";
                              anchor.click();
                              URL.revokeObjectURL(blobURL);
                            })
                            .catch(() => {
                              toast.error("Record not found to export.");
                            });
                        }}
                      >
                        Export
                      </Button>
                    </div>
                  </Col>
                </Row>
              }
            />
          </div>
        </Card>
      </div>
    </div>
  );
}

export default Transporters;
